<div class="inner-content p-30 flex flex-col items-center justify-center gap-7">
  <div class="container flex flex-col items-start justify-center gap-4">
    <h1>Vas a añadir un comentario y esto es importante. Así que LEÉLO, porfi 🙏</h1>
    <p>
      Ten en cuenta que si decides poner un comentario en tu pedido, éste será demorado hasta 2 días en ser producido,
      para que el equipo pueda atenderlo y gestionarlo.
    </p>
    <p>
      Además, si lo que solicitas en tu comentario afecta a la configuración original de tu pedido, es posible que no
      podamos atender tu petición.
    </p>
    <ion-checkbox label-placement="end" [(ngModel)]="checked"> Okay, acepto las condiciones. </ion-checkbox>
    <div class="w-100 flex flex-row gap-2">
      <ion-button color="medium-dark" fill="outline" (click)="cancel()">Cancelar</ion-button>
      <ion-button [disabled]="!checked" class="flex-grow" (click)="submit()">Aceptar y continuar</ion-button>
    </div>
  </div>
</div>
